<template>
  <v-row class="mb-auto" justify="center">
    <v-col cols="12">
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table show-select @toggle-select-all="selectAll" :multi-sort="false" v-model="selected" item-key="Id"
        :headers="headers" :items="mainData" :items-per-page="limit" :options.sync="options"
        :server-items-length="countData" :loading="loading" class="elevation-1 text-no-wrap" show-group-by
        :footer-props="{ itemsPerPageText: '分页:', 'items-per-page-options':[10,20,30,50,100,-1] }">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>发证管理</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn small :color="issearch ? 'error' : 'success'" dark class="mr-2" @click="issearch = !issearch">
              <v-icon>{{issearch ? "mdi-magnify-close" : "mdi-magnify"}}</v-icon>
            </v-btn>
            <v-btn small color="warning" dark @click="delselect">
              删除 <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small color="primary" dark v-bind="attrs" v-on="on">新增</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete :items="lists" :rules="[(v) => !!v || '必填项']" item-text="Name"
                            item-value="Id" v-model="editedItem.Userer.Id" label="生产者"></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field :rules="[(v) => !!v || '必填项']" v-model.trim="editedItem.StartCode" label="起始流水码">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field :rules="[(v) => !!v || '必填项']" v-model.trim="editedItem.EndCode" label="结束流水码">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn color="blue darken-1" :loading="loading" text @click="save">保存</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
  import search from "@/components/search";
  export default {
    components: {
      search,
    },
    data: function () {
      return {
        dialog: false,
        selected: [],
        headers: [{
          text: "生产者",
          value: "Userer.Name",
          groupable: false
        },
        { text: "起始流水码", value: "StartCode", groupable: false },
        { text: "结束流水码", value: "EndCode", groupable: false },
        {
          text: "创建时间",
          value: "CreateAt",
          groupable: false
        },
        {
          text: "更新时间",
          value: "UpdateAt",
          groupable: false
        },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          groupable: false
        },
        ],
        issearch: false,
        mainData: [],
        countData: 0,
        offset: 0,
        limit: this.$store.state.glimit,
        query: "",
        exclude: "",
        sortby: "",
        order: "",
        options: {},
        loading: false,
        editedIndex: -1,
        editedItem: {
          Userer:{
            Id:0,
          }
        },
        defaultItem: {
          Userer:{
            Id:0,
          }
        },
        lists: [],
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "新增" : "编辑";
      },
    },
    watch: {
      dialog(val) {
        if(val){
          if (this.lists.length == 0){
            this.loading = true
            this.$api.getUsers({fields:'Id,Usersproer'}).then(res => {
              this.loading = false
              this.lists = res.data
            }).catch(error => {
              this.loading = false
              let message = (error && error.msg) || "获取用户列表失败！";
              this.$store.commit("setsnack", { message });
              console.error(error);
            })
          }
        }else{
          this.close();
        }
        // val || this.close();
      },
      options: {
        handler() {
          this.limit = this.options.itemsPerPage;
          this.offset = (this.options.page - 1) * this.limit;
          this.sortby = "";
          this.order = "";
          for (let index = 0; index < this.options.sortBy.length; index++) {
            this.sortby += this.options.sortBy[index] + ",";
            this.order += this.options.sortDesc[index] ? "desc," : "asc,";
          }
          if (this.sortby.length > 0) {
            this.sortby = this.sortby.slice(0, -1);
            this.order = this.order.slice(0, -1);
          } else {
            this.sortby = "Id";
            this.order = "desc";
          }
          this.initialize();
        },
        deep: true,
      },
    },
    methods: {
      querydata(query, exclude) {
        this.query = query;
        this.exclude = exclude;
        this.initialize();
      },
      selectAll(item) {
        this.selected = item.value ? item.items : [];
      },
      delselect(e) {
        if (!confirm("确认删除所有选中项吗?")) return;
        if (this.selected.length > 0) {
          let ids = "";
          let arrid = [];
          for (let index = 0; index < this.selected.length; index++) {
            ids += this.selected[index].Id + ",";
            arrid.push(this.selected[index].Id);
          }
          if (ids.length > 0) {
            ids = ids.slice(0, -1);
          }
          this.loading = true
          this.$api.delFazheng({
            id: ids
          }).then((res) => {
            this.loading = false
            for (let index = 0; index < arrid.length; index++) {
              this.mainData = this.mainData.filter(
                (item) => item.Id != arrid[index]
              );
            }
            this.countData -= arrid.length;
          }).catch((error) => {
            this.loading = false
            let message = (error && error.msg) || "删除选中选失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        } else {
          this.$store.commit("setsnack", { message: "尚未选择任何项目", color: "warning" });
        }
      },
      initialize() {
        this.loading = true;
        let data = {
          limit: this.limit,
          offset: this.offset,
        };
        if (this.query != "") {
          data.query = this.query;
        }
        if (this.exclude != "") {
          data.exclude = this.exclude;
        }
        if (this.sortby != "") {
          data.sortby = this.sortby;
          data.order = this.order;
        }
        this.$api.getFazhengs(data).then((res) => {
          this.loading = false;
          if (res.data) {
            this.mainData = res.data;
            this.countData = res.count;
          } else {
            this.mainData = [];
            this.countData = 0;
          }
        }).catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "获取数据列表失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      deleteItem(item) {
        const index = this.mainData.indexOf(item);
        if (confirm("确认删除此项数据吗?")) {
          // Del Item
          const data = {
            id: item.Id,
          };
          this.loading = true;
          this.$api.delFazheng(data).then((res) => {
            this.loading = false;
            this.mainData.splice(index, 1);
            this.countData--;
          }).catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "删除失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.$refs.form.validate()) return;
        this.editedItem.StartCode = parseInt(this.editedItem.StartCode)
        this.editedItem.EndCode = parseInt(this.editedItem.EndCode)
        let data = JSON.parse(JSON.stringify(this.editedItem));
        delete data.CreateAt
        delete data.UpdateAt

        this.editedItem.UpdateAt = this.$utils.formatDate(
          new Date(),
          "yyyy-MM-dd hh:mm:ss"
        );
        this.editedItem.Userer = this.lists.filter(v=>v.Id==this.editedItem.Userer.Id)[0]
        this.loading = true;
        if (this.editedIndex > -1) {
          //Edit Item
        } else {
          this.$api.addFazheng(data).then((res) => {
            this.loading = false;
            this.editedItem.Id = res.data;
            this.editedItem.CreateAt = this.editedItem.UpdateAt;
            this.mainData.unshift(this.editedItem);
            this.countData++;
            this.close();
          }).catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "添加失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
    },
  };
</script>